import { productUpdate } from '../update/UpdateActions';
import { buildAndShowSuccessToast, buildAndShowErrorToast } from '../../../core/actions/toast/ToastActions';
import toastMsg from '../../../../data/toast';
import AnalyticsClient from '../../../../clients/AnalyticsClient';
import productEvents from '../../../../analytics/events/products';
import ProductsServiceClient from '../../../../clients/ProductsService/ProductsServiceClient';

export const nameUpdate = (id, projectId, name, baseApiUrl) => {
  return (dispatch) => {
    ProductsServiceClient.updateName(baseApiUrl, id, projectId, name)
      .then((product) => {
        dispatch(productUpdate(product));
        dispatch(
          buildAndShowSuccessToast({
            // Success! Your product name "{name}" has been renamed.
            messageDescriptor: toastMsg.renameProductSuccessMessage,
            values: { name },
          }),
        );

        AnalyticsClient.trackEvent(productEvents.nameUpdate());
      })
      .catch(() => {
        // Oh oh… Houston we have a problem.
        return dispatch(buildAndShowErrorToast(toastMsg.commonError));
      });
  };
};
